import {
    aksCatalogServiceCode,
    AlbCatalogServiceCode,
    eipStackCatalogServiceCode,
    eventhubCatalogServiceCode,
    iaasOracleCatalogServiceCode,
    iaasSQLCatalogServiceCode,
    iaasVMCatalogServiceCode,
    kafkaCatalogServiceCode,
    keyvaultCatalogServiceCode,
    paasSQLCatalogServiceCode,
    privateEndPointCatalogServiceCode,
    storageAccountCatalogServiceCode,
    iaasCouchbaseServiceCode,
    adfCatalogServiceCode,
} from 'utils/catalogServiceCode';

export const getPayload = ({ appName, data, type }) => {
    const getServiceEndpoints = (vnetSubnet = [], cloudService) => {
        let result = [];
        if (vnetSubnet?.length === 1) {
            vnetSubnet?.forEach((item) => {
                if (item?.vNet === null || item?.subnet === null || item?.networkSubscription === null || item?.networkSubscription === '') result = [];
                if (item?.vNet !== null && item?.subnet !== null && item?.subnet !== '')
                    result = [
                        {
                            networkSubscription: item?.networkSubscription || '',
                            ...(storageAccountCatalogServiceCode === cloudService && {
                                networkSubscriptionId: item?.networkSubscriptionDetails?.id ? item?.networkSubscriptionDetails?.id : '',
                            }),
                            subnet: item?.subnet || '',
                            vnet: { id: item?.vNetDetails?.resourceId || '', name: item?.vNet || '' },
                        },
                    ];
            });
        }
        if (vnetSubnet?.length > 1) {
            return vnetSubnet?.map((item) => ({
                networkSubscription: item?.networkSubscription || '',
                ...(storageAccountCatalogServiceCode === cloudService && {
                    networkSubscriptionId: item?.networkSubscriptionDetails?.id ? item?.networkSubscriptionDetails?.id : '',
                }),
                subnet: item?.subnet || '',
                vnet: { id: item?.vNetDetails?.resourceId || '', name: item?.vNet || '' },
            }));
        }
        return result;
    };
    const payload = {
        ...(type === 'edit' && { id: data?.id || '' }),
        appProfileName: appName,
        isDraft: data?.isDraft || false,
        cloudProvider: data?.cloudProvider || '',
        cloudService: data?.cloudService || '',
        label: data?.landingZoneLabel || '',
        description: data?.landingZoneDesc || '',
        environment: data?.environment || '',
        region: {
            name: data?.regionDetails?.label || '',
            code: data?.regionDetails?.value || '',
        },
        config: {
            ...((iaasVMCatalogServiceCode === data?.cloudService ||
                iaasOracleCatalogServiceCode === data?.cloudService ||
                iaasSQLCatalogServiceCode === data?.cloudService) && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                vnet: {
                    id: data?.vNetDetails?.resourceId || '',
                    name: data?.vNetDetails?.label || '',
                },
                subnet: data?.subNet || '',
                availabilitySet: data?.availSet || '',
                availabilityZone: data?.availZoneDetails?.map((app) => app?.label) || [],
            }),
            ...(paasSQLCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',

                vnetSubnet: getServiceEndpoints(data?.vnetSubnet, data?.cloudService),
            }),
            ...(storageAccountCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
                vnetSubnet: getServiceEndpoints(data?.vnetSubnet, data?.cloudService),
            }),
            ...(aksCatalogServiceCode === data?.cloudService && {
                department: data?.department || '',
                businessUnit: data?.businessUnit || '',
                cluster: data?.cluster || '',
                // projectName: data?.projectName || '',
                isaDocument: data?.ISADocument || '',
            }),
            ...(keyvaultCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                vnet: {
                    id: data?.vNetDetails?.resourceId || '',
                    name: data?.vNetDetails?.label || '',
                },
                subnet: data?.subNet || '',
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
                networkConnectivity: data?.networkConnectivity || '',
                appName: data?.appName || '',
            }),
            ...(kafkaCatalogServiceCode === data?.cloudService && {
                department: data?.department || '',
                cluster: data?.cluster || '',
                projectName: data?.projectName || '',
                businessUnit: data?.businessUnit || '',
                ldapGroup: data?.ldap || '',
                isaDocument: data?.ISADocument || '',
            }),
            ...(AlbCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                vnet: {
                    id: data?.vNetDetails?.resourceId || '',
                    name: data?.vNetDetails?.label || '',
                },
                subnet: data?.subNet || '',
                sku: data?.sku || '',
                type: data?.type || '',
                appName: data?.appName || '',
            }),
            ...(privateEndPointCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                vnet: {
                    id: data?.vNetDetails?.resourceId || '',
                    name: data?.vNetDetails?.label || '',
                },
                subnet: data?.subNet || '',
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
                type: data?.endPointType || '',
                appName: data?.appName,
            }),
            ...(eventhubCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
                geoRecoveryRegion: {
                    name: data?.geoRecoveryRegionDetails?.label || '',
                    id: data?.geoRecoveryRegionDetails?.value || '',
                },
                vnetSubnet: data?.vnetSubnet?.map((item) => ({
                    subnet: item?.subnet || '',
                    vnet: { id: item?.vNetDetails?.resourceId || '', name: item?.vNet || '' },
                })),
            }),
            ...(eipStackCatalogServiceCode === data?.cloudService && {
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
                components: data?.components
                    ?.filter((component) => component?.landingZoneDetails?.id)
                    ?.map((item) => ({
                        ...(type === 'edit' && { componentId: item?.componentId }),
                        landingzoneId: item?.landingZoneDetails?.id,
                        name: item?.name,
                        provider: item?.provider,
                        service: item?.service,
                        optional: item?.optional,
                    })),
                connections: data?.connections
                    ?.filter((connection) => data?.components?.find((component) => component?.name === connection?.targetComponentId)?.landingZoneDetails?.id)
                    ?.map((item) => ({
                        connectionType: item?.connectionType,
                        name: item?.name,
                        sourceComponent: item?.sourceComponentId,
                        targetComponent: item?.targetComponentId,
                    })),
            }),
            ...(iaasCouchbaseServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                vnet: {
                    id: data?.vNetDetails?.resourceId || '',
                    name: data?.vNetDetails?.label || '',
                },
                subnet: data?.subNet || '',
                availabilityZone: data?.availZoneDetails?.map((app) => app?.label) || [],
            }),
            ...(adfCatalogServiceCode === data?.cloudService && {
                subscription: {
                    id: data?.subscriptionDetails?.id || '',
                    name: data?.subscriptionDetails?.label || '',
                },
                resourceGroup: data?.resGroup || '',
                dataClassification: {
                    displayName: data?.dataClassification || '',
                    value: data?.dataClassificationDetails?.value || '',
                },
            }),
        },
    };
    return payload;
};
export default getPayload;
